import { Dialog } from 'primereact/dialog';
import styled from 'styled-components';

/**
 * The dialog a content editor opens in: full width and height up to the point
 * where it would crowd the viewport, with the editable item name as its header.
 */
export const EditorModalDialog = styled(Dialog)`
  width: 100%;
  height: 100%;
  max-height: 95vh;
  max-width: 1500px;

  .p-dialog-header {
    padding: var(--medium-padding) var(--medium-big-padding);
    border-bottom: 1px solid var(--gray-dark);

    h1 {
      font-weight: 600;
      font-size: var(--heading-small-font-size);
      margin: 0;
    }
  }
`;
